import OrderItemsPreview from './OrderItemsPreview';

export default OrderItemsPreview;
